import { FC } from 'react';

import { FormTabs } from 'components';
import { Stack } from 'libs/ui';
import { ClientMainInfo } from 'modules/client/common/components/ClientMainInfo';
import {
  CountryRiskProvider,
  CountryRiskRole,
} from 'modules/client/common/feature';

import { LegalClientBeneficiarySectionsProps } from './types';
import { useLegalClientBeneficiarySections } from './useLegalClientBeneficiarySections';

export const LegalClientBeneficiarySections: FC<
  LegalClientBeneficiarySectionsProps
> = ({ countryRiskAt, ...props }) => {
  const { tabs, info } = useLegalClientBeneficiarySections(props);

  return (
    <CountryRiskProvider
      at={countryRiskAt}
      role={CountryRiskRole.LegalClientBeneficiary}
    >
      <Stack spacing={36}>
        {info && <ClientMainInfo info={info} />}
        <FormTabs tabs={tabs} />
      </Stack>
    </CountryRiskProvider>
  );
};
